module.exports = __webpack_public_path__ + "img/wemlo-logo-for-light-bg.b0be5acf.png";